// @flow

import React from "react";

import MyConversationChart from "./MyConversationChart";
import Conversations from "./Conversations";
import StartNew from "./StartNew";
import DashboardChart from "./DashboardChart";
import Reports from "./Reports";

import type { HomescreenTile } from "src/types";

type Props = {
  tile: HomescreenTile,
  sectionId: number,
};

const Tile = ({ tile, sectionId }: Props) => {
  switch (tile.tileType) {
    case "conversations":
      return <Conversations tile={tile} sectionId={sectionId} />;
    case "my_conversation_chart":
      return <MyConversationChart tile={tile} sectionId={sectionId} />;
    case "start_new":
      return <StartNew tile={tile} sectionId={sectionId} />;
    case "dashboard_chart":
      return <DashboardChart tile={tile} sectionId={sectionId} />;
    case "reports":
      return <Reports tile={tile} sectionId={sectionId} />;
    default:
      return <></>;
  }
};

export default Tile;
